import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


export interface RenderState {
  components: IdtComponent[];
  country: string | null;
  device: string | null;
  lang: string | null;
  timeTravelTo: string | null;
  userFlags: string | null;
}

export const initialRenderState: RenderState = {
  components: [],
  country: null,
  device: null,
  lang: null,
  timeTravelTo: null,
  userFlags: null
};
